<template>
    <ModalComponent
        name="partidosModal"
        title="Partidos del abono"
        @close="$emit('close')"
        @opened="getEventos()"
    >
        <div v-if="loading" class="text-center py-4">
            <div class="spinner-border" role="status">
            </div>
            <p class="mt-2">{{$t('perfil_sga.cargando')}}</p>
        </div>
        <div v-else-if="entradas.length == 0" class="text-center py-4">
            <b-icon icon="calendar-x" style="font-size: 3rem;" class="text-muted mb-3"/>
            <p class="text-muted">{{$t('perfil_sga.no_eventos_cesion')}}</p>
        </div>
        <div class="row" v-else>
            <div class="col-12 mb-3" v-for="entrada in entradas" :key="entrada.id">
                <b-card class="border shadow-sm">
                    <b-card-body class="p-3">
                        <div class="w-100 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                            <div class="d-flex align-items-center p-2 mb-2 mb-md-0">
                                <p class="mb-0 font-weight-bold">{{ entrada.event_object.name  }}</p>
                            </div>                            
                            <div class="d-flex align-items-center font-weight-normal">
                                <b-icon icon="calendar"  />
                                <p class="mb-0 px-3">{{ entrada.event_object.date }}</p>
                            </div>
                            <div class="p-2" v-if="entrada.beneficiary.profileId == perfil.id">
                                <button v-if="entrada.status == 'Active'" class="btn btn-primary" @click="liberarEntrada(entrada)" :disabled="enviando">
                                    {{ $t('perfil.liberar_asiento') }}
                                </button>
                                <button v-else-if="entrada.status == 'Ceded'" class="btn btn-primary" @click="recuperarEntrada(entrada)" :disabled="enviando">
                                    {{ $t('perfil_sga.recuperar') }}
                                </button>
                                <button v-else-if="entrada.status == 'Ceding' || entrada.status == 'Recovering'" class="btn btn-info" style="cursor: default;" disabled>
                                    {{ $t('perfil_sga.en_proceso') }}
                                </button>
                                <div v-else class="btn-danger p-2 rounded" style="cursor: not-allowed;">
                                    {{ $t('perfil_sga.no_disponible') }}
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="w-100 d-flex justify-content-center">
                            <h4>{{getStatusText(entrada.status)}}</h4>
                        </div>
                        <hr v-if="entrada.beneficiary.profileId != perfil.id && entrada.status == 'Active'"/>
                        <div class="w-100 d-flex justify-content-center" v-if="entrada.beneficiary.profileId != perfil.id && entrada.status == 'Active'">
                            <div class="w-100 d-flex justify-content-between d-md-block">
                                <div class="w-auto d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center pr-0 pr-md-4">
                                    <div class=" w-auto d-flex flex-column flex-md-row align-items-start align-items-md-center">
                                        <div class="border d-none d-lg-flex align-items-center justify-content-center p-1 mr-3 rounded-circle overflow-hidden mb-2 mb-md-0" style="width: 50px; height: 50px;">
                                            <b-icon icon="person" class="w-100 h-100"/>
                                        </div>
                                        <div>
                                            <div class="d-flex mb-2">
                                                <p class="mb-0 mr-2"> {{ entrada.beneficiary.profile.name }}</p>
                                                <p class="mb-0"> {{ entrada.beneficiary.profile.lastName }} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="d-flex font-weight-normal mb-2">
                                            <b-icon icon="card-text" class="mr-2" />
                                            <p class="mb-0"> {{ entrada.beneficiary.profile.identification.value }} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        name: "PartidosModal",
        props: {
            abono: {
                type: Object,
                required: true
            },
            perfil: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                entradas: null,
                enviando: false,
                refreshTimer: null
            };
        },
        beforeDestroy() {
            if (this.refreshTimer) {
                clearTimeout(this.refreshTimer);
                this.refreshTimer = null;
            }
        },
        methods: {
            getEventos() {                
                const params = {
                    abonado_id: this.abono.id
                };
    
                this.$store.dispatch(this.config.getVuexAlias("sga.profile.abono.entradas"), params).then(res => {
                    this.entradas = res.data.data;
                    this.programarActualizacionPendiente();
                }).catch(error => {
                    this.$toast.error(this.$t('perfil_sga.error_carga_eventos'));
                    this.entradas = null;
                }).finally(() => {
                    this.loading = false;
                });
            },
            programarActualizacionPendiente() {
                const pendiente = (this.entradas || []).some(entrada =>
                    entrada.status === 'Ceding' || entrada.status === 'Recovering'
                );

                if (pendiente && !this.refreshTimer) {
                    this.refreshTimer = setTimeout(() => {
                        this.refreshTimer = null;
                        this.getEventos();
                    }, 3000);
                }
            },
            liberarEntrada(entrada) {
                if (this.enviando) return;
                this.enviando = true;

                const params = {
                    ticketEntitlementId: entrada.id
                };

                this.$store.dispatch(this.config.getVuexAlias("sga.evento.ceder"), params).then(res => {
                    this.$toast.success(this.$t('perfil.asiento_liberado'));
                }).catch(error => {
                    console.error(error);
                    const mensaje = error?.response?.data?.message;
                    this.$toast.error(mensaje || this.$t('perfil.liberar_error_asiento'));
                }).finally(() => {
                    this.enviando = false;
                    this.getEventos();
                });
            },
            recuperarEntrada(entrada) {
                if (this.enviando) return;
                this.enviando = true;

                const params = {
                    ticketEntitlementId: entrada.id
                };

                this.$store.dispatch(this.config.getVuexAlias("sga.evento.recuperar"), params).then(res => {
                    this.$toast.success(this.$t('perfil_sga.evento_recuperado_correctamente'));
                }).catch(error => {
                    console.error(error);
                    this.$toast.error(this.$t('perfil_sga.error_recuperar_evento'));
                }).finally(() => {
                    this.enviando = false;
                    this.getEventos();
                });
            },
            getStatusText(status) {
                switch (status) {
                    case 'Active':
                        return 'Activo';
                    case 'Ceding':
                        return 'Liberando asiento';
                    case 'Recovering':
                        return 'Recuperando asiento';
                    case 'CededSold':
                        return 'Asiento liberado y vendido';
                    case 'Ceded':
                        return 'Asiento liberado';
                    case 'CededSoldFinalized':
                        return 'Asiento liberado y vendido (finalizado)';
                    default:
                        return status;
                }
            }
        },
        components: {
            ModalComponent
        }
    };
</script>
